export function populateGraphComponent({ newData, processor, dataRef, setSeries, readyRef = null }) {
    if (newData && newData.length > 0) {
        if(readyRef) {
            readyRef.value = false
        }
        const processedData = processor(newData);
        if(setSeries) {
            setSeries(processedData)
        }
        else {
            dataRef.value = processedData;
        }
        if (readyRef) {
            readyRef.value = true;
        }
    } 
    else if (readyRef) {
        readyRef.value = false;
    }
}

export function bindSetGraphsReady(readyRef) {
  return (value) => readyRef.value = value;
}